<template>
    <div class="borrow">
        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <DatePicker type="date" v-model="start" placeholder="选择开始日期" style="width: 200px" />
            <DatePicker type="date" v-model="end" placeholder="选择结束日期" style="width: 200px" />
            <Button type="primary" @click="loadData(currentPage)">搜索</Button>
            <Button type="primary" @click="expectProduct">预开奖</Button>
            <div style="display: flex; flex-direction: row; gap: 10px; background-color: #f93f36; padding: 10px; border-radius: 5px; color: #fff;width: 280px;">
                <Input type="number" v-model="number" placeholder="请输入开奖数量" style="width: 200px; color: #fff;" />
                <Button type="primary" @click="openMany">批量开奖</Button>
            </div>
            <Button type="primary" @click="clearHistory">清理记录</Button>
        </div>
        <div class="next_info">
            <span>下一期期数：{{ nextInfo.period }}</span>
            <span>下一期开奖时间：{{ new Date(nextInfo.time).toLocaleString({ hour: '2-digit', minute: '2-digit', second: '2-digit' }) }}</span>
            <span>倒计时：{{ nextInfo.countDown }}</span>
        </div>
        <Table border :columns="columns12" :data="data6" style="width: 100%;">
            <template slot-scope="{ row }" slot="name">
                <strong>{{ row.name }}</strong>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
          
        <Modal v-model="showExpectModal" title="预开奖" @on-ok="expectProductOk">
           <div v-for="(item, index) in 5" :key="index" >
             <div style="font-size: 20px; font-weight: bold;">{{ Number(nextInfo.period) + index }}</div>
             <div style="display: flex; flex-direction: row; gap: 10px;">
                <Button @click="expectProductItem(index, 'big_odd')" :class="{'active': expectItem[index] && expectItem[index].result == 'big_odd'}">大单</Button>
                <Button @click="expectProductItem(index, 'big_even')" :class="{'active': expectItem[index] && expectItem[index].result == 'big_even'}">大双</Button>
                <Button @click="expectProductItem(index, 'small_odd')" :class="{'active': expectItem[index] && expectItem[index].result == 'small_odd'}">小单</Button>
                <Button @click="expectProductItem(index, 'small_even')" :class="{'active': expectItem[index] && expectItem[index].result == 'small_even'}">小双</Button>
             </div>
           </div>
        </Modal>
        <Modal v-model="showClearModal" title="清理记录" >
            <div>
                <Button @click="clearHistoryItem(7)">1周之前</Button>
                <Button @click="clearHistoryItem(15)">半月之前</Button>
                <Button @click="clearHistoryItem(30)">1个月之前</Button>
            </div>
        </Modal>
        <Modal
            v-model="showDelModal"
            :title="$t('del')"
            @on-ok="delRowOk()"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>
        
    </div>
</template>
<script>
import { title } from 'echarts/lib/theme/dark.js';
import { formatUTCTime as formatUTC } from '../../common/common.js';
export default {
    data() {
        return {
            id: '',
            expectItem: [],
            showDelModal: false,
            productIdToDel: 0,
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            search: "",
            start:'',
            end:'',
            nextInfo: {
                period: '',
                time: '',
                countDown: ''
            },
            title: '编辑',
            showExpectModal: false,
            totalItems: 1,
            img_load: false,
            number: 0,
            logo: '',
            showEditModal: false,
            showClearModal: false,
            columns12: [
                {
                    title: "ID",
                   
                    key: "id",
                },
                
                {
                    title: "期数",
                    
                    key: "period_number",
                },

                {
                    title: "号码",
                    
                    key: "numbers",
                },
                {
                    title: "开奖时间",
                    
                    key: "open_time",
                    render: (h, params) => {
                        return h("div", [
                            h("span", formatUTC(params.row.open_time, 8))
                        ]);
                    }
                },
                {
                    title: "预开结果",
                    
                    key: "expect_result",
                    render: (h, params) => {
                        return h("div", [
                            h("span", this.formatExpectResult(params.row.expect_result))
                        ]);
                    }
                },
                {
                    title: this.$i18n.t('status'),
                    
                    key: "status",
                    render: (h, params) => {
                        if (params.row.status == 0) {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: 'md-close',
                                        size: 24,
                                        color: 'red'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit_status(params.row, 0)
                                        }
                                    }
                                }, '未开奖')
                            ])
                        } else {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: 'md-checkmark',
                                        size: 24,
                                        color: 'green'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit_status(params.row, 1)
                                        }
                                    }
                                }, '已开奖')
                            ])
                        }
                    }
                },

                {
                    title:this.$i18n.t('action'),
                    
                    align: 'center',
                    key: "action",
                    render: (h, params) => {
                        return h("div",{style:{display: 'flex', flexDirection: 'row', justifyContent: 'center',alignItems: 'center',gap: '5px'}}, [
                            h("Icon", {
                                props: {
                                    type: 'md-create',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                    backgroundColor: 'blue',
                                    border: 'none',
                                },
                                on: {
                                    click: () => {
                                        this.editModal(params.row)
                                    }
                                }
                            }),
                            h("Icon", {
                                props: {
                                    type: 'md-trash',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                    backgroundColor: 'red',
                                    border: 'none',
                                },
                                on: {
                                    click: () => {
                                        this.delRow(params.row)
                                    }
                                }
                            })
                        ]);
                    }
                }
            ],
            data6: []
        };
    },
    
    mounted() {
        
        this.id = this.$route.query.id;
        this.loadData(1);
        //每秒更新一次倒计时
        setInterval(() => {
            this.nextInfo.countDown--;
            if (this.nextInfo.countDown <= 0) {
                this.nextInfo.countDown = 0;
                this.loadData(1);
            }
        }, 1000);
    },
    methods: {
        openMany() {
            this.$post(this.$path.open_many, {
                id: this.id,
                number: this.number
            }).then(res => {
                if (res.errcode == 0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                }
            });
        },
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.history_list, {
                id: this.id,
                page: this.currentPage,
                search: this.search,
                start: this.start,
                end: this.end
            }).then(res => {
                if (res.errcode == 0) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                    this.nextInfo = {
                        period: res.data.next_period || '',
                        time: res.data.next_time || '',
                        countDown: res.data.countdown|| ''
                    };
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        clearHistory() {
            this.showClearModal = true;
        },
        clearHistoryItem(days) {
            this.$post(this.$path.clear_history, {
                id: this.id,
                days: days
            }).then(res => {
                if (res.errcode == 0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(res.error || this.$i18n.t('operateFailed'));
                }
            }).finally(() => {
                this.showClearModal = false;
            });
        },
        expectProduct() {
            // 初始化 expectItem 数组，确保有5个元素
            this.expectItem = [];
            for (let i = 0; i < 5; i++) {
                this.expectItem.push({
                    period_number: Number(this.nextInfo.period) + i,
                    result: ''
                });
            }
            this.showExpectModal = true;
        },
        expectProductItem(index, type) {
            // 更新对应索引的元素，而不是 push
            if (this.expectItem[index]) {
                this.expectItem[index].result = type;
                this.expectItem[index].period_number = Number(this.nextInfo.period) + index;
            } else {
                // 如果不存在，则创建
                this.$set(this.expectItem, index, {
                    period_number: Number(this.nextInfo.period) + index,
                    result: type
                });
            }
        },
        expectProductOk() {
            // 过滤掉没有选择结果的项
            const validItems = this.expectItem.filter(item => item && item.result);
            if (validItems.length === 0) {
                this.$Message.warning('请至少选择一个预开奖结果');
                return;
            }
            this.$post(this.$path.expect_product, {
                id: this.id,
                expect_item: validItems
            }).then(res => {
                if (res.errcode == 0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.showExpectModal = false;
                    this.expectItem = [];
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(res.error || this.$i18n.t('operateFailed'));
                }
            });
        },
        delRow(row) {
            this.productIdToDel = row.id;
            this.showDelModal = true;
        },
        delRowOk() {
            this.$post(this.$path.product_del, { 
                id: this.productIdToDel
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.showDelModal = false;
                    this.productIdToDel = 0;
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delModal(row) {
            this.modalItem = row;
            this.showDelModal = true;
        },
        change_status(row) {
            this.modalItem = row;
            this.change_sts = true;
            this.$get(this.$path.change_status).then(res => {
                if (res.success) {
                    this.status_data = res.data;
                }
            });
        },
       formatExpectResult(result) {
        if (result == 'big_odd') {
            return '精品单件';
        } else if (result == 'big_even') {
            return '精品双件';
        } else if (result == 'small_odd') {
            return '普货单件';
        } else if (result == 'small_even') {
            return '普货双件';
        }
        return result;
       },
        edit_status(row,status) {
            this.$post(this.$path.change_status, {
                order_id: row.id,
                status: status,
                user_id: row.user_id,
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        
    }
};
</script>
<style lang="scss" scoped>
.search {
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-bottom: 20px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.jt_img {
    width: 100%;
    img {
        width: 100%;
    }
}
.order_num {
    display: flex;
    flex-direction: row;
    .tit {
        width: 60px;
        color: #bab9b9;
    }
    .info {
        width: 200px;
    }
}
.sts_list {
    margin-top: 10px;
    .tit {
        width: 100px;
        color: #bab9b9;
    }
}
.op_btn {
    margin-top: 5px;
}
.op_btn:nth-child(2) {
    margin-bottom: 5px;
}
/*.radio_div {
     width: 25%; 
}*/
.ivu-radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.red_color{
    color: red;
}
.file_box {
        display: flex;
        flex-direction: column;
        width: 200px;
        height: 170px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border: 1px #eeeeee dashed;
        border-radius: 4px;
        margin-right: 20px;
        .show_big_img {
            width: 100%;
            height: 20px;
            cursor: pointer;
            text-align: center;
        }
        img {
            width: 100%;
            height: 130px;
        }
        .img {
            width: 100%;
            height: 100%;

            p {
                text-align: center;
                color: #bab9b9;
                // margin-top: 20px;
            }
        }
        input {
            position: absolute;
            top: 0;
            left: 0;
            width: 200px;
            height: 150px;
            opacity: 0;
            }
        }
    .next_info {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        span {
           color: #111010;
           font-size: 20px;
           font-weight: bold;
        }
    }
    .active {
        background-color: #2d8cf0;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/product/history.vue